import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-arrow-right-icon',
  template: `
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_45708_11155)">
        <path
          d="M6.44336 12.4425L9.87836 9L6.44336 5.5575L7.50086 4.5L12.0009 9L7.50086 13.5L6.44336 12.4425Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_45708_11155">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowRightIconComponent {}
